import {isMobileAndroidApp, isMobileApp, isMobileIosApp} from "./appUtils";
import WebviewMessage, { RN_APP_API_TYPE } from "../../components/appConnect/WebviewMessage";
import {registerDevice} from "../../services/restapi/mypage/index";

const moveExternalLink = (event, externalLink, externalTarget) => {
  if (!event) return false;
  event.preventDefault();
  const { target } = event;
  const linkUrl = externalLink ? externalLink : target.attributes.href ? target.attributes.href.value : null;
  if (!linkUrl) return false;
  if (isMobileApp()) {
    (async () => {
      await WebviewMessage(RN_APP_API_TYPE.MOVE_EXTERNAL_LINK, linkUrl).catch(() => null);
    })()
  } else {
    const linkTarget = target.attributes.target ? target.attributes.target.value : "";

    if ("_blank" === linkTarget || "_blank" === externalTarget) {
      window.open(linkUrl, "_blank");
    } else {
      location.href = linkUrl;
    }
  }
};

export const moveSubscriptionSetting = () => {
  if (isMobileIosApp()) {
    (async () => {
      await WebviewMessage(RN_APP_API_TYPE.MOVE_EXTERNAL_LINK, 'https://apps.apple.com/account/subscriptions').catch(() => null);
    })();
  } else {
    window.open('https://apps.apple.com/account/subscriptions');
  }
};

export const registerPushDevice = async () => {
  const getDeviceState = async () => {
    return await WebviewMessage(RN_APP_API_TYPE.GET_DEVICE_STATE).catch(() => null);
  };
  const deviceState = await getDeviceState();
  if (deviceState) {
    const device = {};
    device["osType"] = isMobileIosApp() ? "IOS" : isMobileAndroidApp() ? "ANDROID" : "ANY";
    device["playerId"] = deviceState.userId;
    await registerDevice(device);
  }
};

export const openAppConfirmAlert = async(alertType, title, content) => {
  return await WebviewMessage(RN_APP_API_TYPE.OPEN_CONFIRM_ALERT, {title: title, content: content, alertType: alertType}).catch(() => null);
};
let isSharing = false;
export const openShare = (title, message, url) => {
  if (isMobileApp()) {
    if (!isSharing) {
      (async () => {
        isSharing = true;
        await WebviewMessage(RN_APP_API_TYPE.OPEN_SHARE, {
          title: title,
          message: message,
          url: url,
          isNewTask:true
        }).catch(() => null);
        setTimeout(function () {
          isSharing = false;
        }, 500);
      })();
    }
  } else {
    if (navigator.share) {
      navigator.share({
        title: title,
        text: message,
        url: url,
      });
    } else {
      alert("공유하기가 지원되지 않는 환경 입니다.")
    }
  }
};


export default moveExternalLink;
